import { API } from "../../API_CONFIG";
export const ODIcon = (props) => {
    const { src, height, width, alt, className} = props;
    return (

          <img
            style={{ width: width, height: height, }}
            src={API.views_medibuddy_url + src}
            alt={alt?alt:""}
            className={className}
          />    
    );
  }
  